import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/LanguageSwitcher.css';

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const languages = [
    { code: 'en', flag: '🇬🇧', label: 'EN', fullName: 'English' },
    { code: 'pl', flag: '🇵🇱', label: 'PL', fullName: 'Polski' },
    { code: 'de', flag: '🇩🇪', label: 'DE', fullName: 'Deutsch' },
    { code: 'es', flag: '🇪🇸', label: 'ES', fullName: 'Español' },
    { code: 'fr', flag: '🇫🇷', label: 'FR', fullName: 'Français' },
    { code: 'it', flag: '🇮🇹', label: 'IT', fullName: 'Italiano' },
    { code: 'uk', flag: '🇺🇦', label: 'UK', fullName: 'Українська' }
  ];

  const currentLanguage = languages.find(
    (lang) => i18n.language === lang.code || i18n.language.startsWith(lang.code)
  ) || languages[0];

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Close dropdown on escape key
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, []);

  return (
    <div className="language-switcher" ref={dropdownRef}>
      <button
        className={`language-toggle ${isOpen ? 'open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="listbox"
      >
        <span className="lang-flag">{currentLanguage.flag}</span>
        <span className="lang-label">{currentLanguage.label}</span>
        <span className="dropdown-arrow">▾</span>
      </button>

      {isOpen && (
        <ul className="language-dropdown" role="listbox">
          {languages.map((lang) => (
            <li key={lang.code} role="option" aria-selected={currentLanguage.code === lang.code}>
              <button
                className={`language-option ${currentLanguage.code === lang.code ? 'active' : ''}`}
                onClick={() => changeLanguage(lang.code)}
              >
                <span className="lang-flag">{lang.flag}</span>
                <span className="lang-name">{lang.fullName}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default LanguageSwitcher;
